import React from "react";
import { useParams } from 'react-router-dom'

import MippumAppBar from "@/components/common/MippumAppBar";
import MippumDrawer from "@/components/common/MippumDrawer";
import { Box } from "@mui/material";

import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const Page = () => {
    const portrait = window.innerWidth < 1100;
    const [drawerOpen, setDrawerOpen] = React.useState(!portrait);
    const { id } = useParams();

    const [detail, setDetail] = React.useState('');

    const detailUrl = process.env.PUBLIC_URL + '/content/epub/self-affirmation/' + id + '.md';

    React.useEffect(() => {
        const init = async () => {
            const result = await fetch(detailUrl);
            const detailText = await result.text();
            setDetail(detailText);
        }
        init();
    }, []);

    // TODO: 특정 width 기준 drawer open 설정
    // TODO: drawer open 시 view 들여쓰기

    return (<Box sx={{display:'grid'}}>
        <MippumAppBar title='미쁨자기확언' drawerOpen={drawerOpen} toggleDrawer={()=>{setDrawerOpen(!drawerOpen)}} />
        <MippumDrawer drawerOpen={drawerOpen} />
        <Markdown remarkPlugins={[remarkGfm]}>{detail}</Markdown>
    </Box>)
}

export {Page};
